import ax from '../axios'
import {API_URL} from "../index";

const SUB_USER_URL = API_URL.USER_MODULE + '/sub-user'

const getSubUserAvatars = (query: string) => {
    return ax.get(`${SUB_USER_URL}/avatars?${query}`)
}
export {
    getSubUserAvatars
}
